/**
 * The base colour a background selector tile shows for a background that is
 * not selected: the colour the banner gets when the user selects that
 * background. It follows the same order as the editor:
 *
 * 1. The banner's own base in the scene (`bases`), on the scopes channels
 *    (useInitialScene loads `bases`, useSceneScope draws `bases[id] ?? base`).
 * 2. The scene's `base`, if it is not the universal "000".
 * 3. The catalog item's `base` (App's bg-linked base), if it is not "000".
 * 4. The scene's `base`, else "000" (App's `defaultBase`).
 */

interface TileBaseInput {
  /** The default scene that the background resolves to. */
  scene: Record<string, unknown> | null | undefined;
  /** The `base` of the background's catalog item. */
  catalogBase: string | null | undefined;
  templateId?: string;
  /** True on the channels that keep a base per banner (isScopesChannel). */
  perBanner?: boolean;
}

const UNIVERSAL_BASE = "000";

export function tileBaseColor({scene, catalogBase, templateId, perBanner}: TileBaseInput): string {
  if (perBanner && templateId) {
    const bases = scene?.bases;
    if (bases && typeof bases === "object") {
      const own = (bases as Record<string, unknown>)[templateId];
      if (typeof own === "string" && own) return own;
    }
  }
  const sceneBase = typeof scene?.base === "string" ? scene.base : "";
  if (sceneBase && sceneBase !== UNIVERSAL_BASE) return sceneBase;
  if (catalogBase && catalogBase !== UNIVERSAL_BASE) return catalogBase;
  return sceneBase || UNIVERSAL_BASE;
}
